import { MigrationPage } from "../MigrationPage";

const DagGraphs = () => <MigrationPage title="Dag Graphs" pageType="Dag Graphs" />;

export default DagGraphs;
